import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var UrlHelper =
/*#__PURE__*/
function () {
  function UrlHelper() {
    _classCallCheck(this, UrlHelper);
  }

  _createClass(UrlHelper, [{
    key: "addOptionsToUrl",

    /**
    * Adds query parameters to given url
    * @param url Url to which options will be added
    * @param options Query parameters to add
    */
    value: function addOptionsToUrl(url, options) {
      if (options) {
        options.forEach(function (filter) {
          if (url.indexOf('?') > -1) {
            url += '&';
          } else {
            url += '?';
          }

          url += filter.getParam();
        });
      }

      return url;
    }
  }]);

  return UrlHelper;
}();
export var urlHelper = new UrlHelper();